import { render, staticRenderFns } from "./ScrollDownPage.vue?vue&type=template&id=0c3551d3&"
import script from "./ScrollDownPage.vue?vue&type=script&lang=ts&"
export * from "./ScrollDownPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports